import React, { FC, ReactNode } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import { Grid, Drawer } from '@material-ui/core';

import { Dispatch, iRootState } from '../../store';

import Scrollbar from '../../components_/Scrollbar';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

const width = 380;

const useStyles = makeStyles(({ spacing, colors }) => ({
  paper: ({ isExpand, isSub }: IStyleProps) => ({
    width: isExpand ? width : 50,
    left: isSub ? width : 0,
    paddingTop: spacing(6.5),
    paddingBottom: spacing(9),
    boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.08)',
    zIndex: 0,
    transition: '0.1s'
  }),
  back: {
    margin: `${spacing(1.5)}px auto`,
    transform: 'rotate(180deg)',
    color: colors.greySteel
  },
  iconButton: {
    padding: 0
  }
}));

const mapState = (state: iRootState) => ({
  isExpand: state.drawer.isExpand
});

const mapDispatch = (dispatch: any) => {
  const d = dispatch as Dispatch;

  return {
    expendDrawer: d.drawer.expandDrawer,
    getMap: () => d.infrastructureMap.getMap(undefined as any)
  };
};

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

interface IStyleProps {
  isExpand?: boolean;
  isSub?: boolean;
}

type IProps = {
  isSub?: boolean;
  children: ReactNode;
} & connectedProps;

const DrawerAnt: FC<IProps> = ({ isSub, isExpand, children, expendDrawer, getMap }) => {
  const classes = useStyles({ isSub, isExpand });

  const handleClick = () => {
    expendDrawer();
    getMap();
  };

  return (
    <Drawer classes={{ paper: classes.paper }} variant="permanent">
      {isExpand ? (
        <Scrollbar>{children}</Scrollbar>
      ) : (
        <Grid className={classes.back}>
          <Button
            type={'text'}
            className={classes.iconButton}
            onClick={handleClick}
            icon={<ArrowLeftOutlined />}
          />
        </Grid>
      )}
    </Drawer>
  );
};

const withConnect = connect(mapState, mapDispatch);

export default withConnect(DrawerAnt);
